import { render, staticRenderFns } from "./collapsible-tag-list.html?vue&type=template&id=7836dca6&scoped=true&"
import script from "./collapsible-tag-list.js?vue&type=script&lang=js&"
export * from "./collapsible-tag-list.js?vue&type=script&lang=js&"
import style0 from "./collapsible-tag-list.scss?vue&type=style&index=0&id=7836dca6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836dca6",
  null
  
)

export default component.exports